import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SceneLayout } from "src/components/SceneLayout";
import { Button, Flex } from "@chakra-ui/react";
import { H2 } from "src/atoms/typography";
import { Scanner } from "@yudiel/react-qr-scanner";
import ScannerUI from "./components/ScannerUI";

export default function EnterCode({ onChange, flow, mode, processing }) {
  const { t } = useTranslation();
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    const videoElement = document.querySelector("video");
    if (videoElement) {
      const onVideoLoad = () => {
        setVideoReady(true);
      };

      videoElement.addEventListener("loadeddata", onVideoLoad);
      return () => {
        videoElement.removeEventListener("loadeddata", onVideoLoad);
      };
    }
  }, []);

  return (
    <SceneLayout
      centerProps={{
        width: "100%",
        height: "100%",
        bg: "black",
        borderRadius: mode === "fullScreen" ? 0 : "12px"
      }}
      center={
        <>
          <Flex
            overflow="hidden"
            h="100%"
            w="100%"
            flexDir="column"
            pos="relative"
            alignItems="center"
            borderRadius={mode === "fullScreen" ? 0 : "12px"}
          >
            <Flex
              flexDir="column"
              pos="absolute"
              top="44px"
              alignItems="center"
              w="100%"
              h="100%"
              maxW="320px"
              zIndex={2}
            >
              <ScannerUI mode={mode} videoReady={videoReady} processing={processing} />
              {videoReady && (
                <H2 textAlign="center" color="white" mt="32px">
                  {t("pairing.scanFromSecondDevice")}
                </H2>
              )}
            </Flex>
            <Scanner
              onScan={(result) => {
                const appCode = result[0].rawValue.includes("/pairing/")
                  ? result[0].rawValue.split("/pairing/")[1]
                  : null;
                const betterSpaceCode = result[0].rawValue.includes("code=")
                  ? result[0].rawValue.split("code=")[1]
                  : null;
                onChange(appCode || betterSpaceCode);
              }}
              components={{
                finder: false,
                audio: false
              }}
              styles={{
                video: {
                  objectFit: "cover",
                  pos: "absolute",
                  width: "100%",
                  height: "100%"
                }
              }}
            />
          </Flex>
        </>
      }
      bottom={
        <Button pos="absolute" zIndex={2} bottom="24px" onClick={() => flow.push("enter-code")}>
          {t("enterCodeManually")}
        </Button>
      }
    />
  );
}
